import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from './../environments/environment';
import { CookieServiceService } from './cookie-service.service';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  baseurl = environment.baseURL;

  constructor(private http: HttpClient, private cookieService: CookieServiceService) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/octet-stream; charset=utf-8',
      'Content-Disposition': 'filename="file.pdf";filename*="file.pdf"'
    })
  }

  makeGetRequest(url: string): any {
    url = this.baseurl + url;
    var header = this.generateAuthenticationHeader();
    if (this.generateAuthenticationHeader()) {      
      return this.http.get(url, header);
    }
    return this.http.get(url);
  }
  makeGetRequest_1(url: string): any {
    url = this.baseurl + url;
    var header = this.generateAuthenticationHeader();
    if (this.generateAuthenticationHeader()) {      
      return this.http.get(url, header);
    }
    return this.http.get(url).toPromise();
  }

  makePostRequest(data: any, url: string): any {
    url = this.baseurl + url;
    var header = this.generateAuthenticationHeader();
    if (this.generateAuthenticationHeader()) {
      return this.http.post(url, data, header);
    }
    return this.http.post(url, data);
  }

  fileManagementRequest(data: any, url: string): any {

    var HTTPOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/pdf',
        'token': this.cookieService.getJWTToken(),'Content-Type': 'application/json',
      }),
      'responseType': 'blob' as 'json'
    }
    url = this.baseurl + url;
    if (this.generateAuthenticationHeader()) {
      return this.http.post(url, data, HTTPOptions);
    }
    return this.http.post(url, data);
  }

  generateAuthenticationHeader() {
    if (this.cookieService.getJWTToken()) {
      return {
        headers: new HttpHeaders({
          'token': this.cookieService.getJWTToken()
        })
      };
    } else {
      return;
    }
  }
}
